import axios from 'axios';

export type CrmLoadPCustomerParams = {
	// data
	email: string,
	// token
	getToken: () => Promise<string>,
	// callbacks
	setState?: (data: any) => void,
	setError?: (error: string) => void
};

export const crmLoadCustomer = async (params: CrmLoadPCustomerParams): Promise<[any, string | null]> => {
	// eslint-disable-next-line no-empty-function, @typescript-eslint/no-empty-function
	const { email, getToken, setState, setError } = params;

	try {
		const token = await getToken();
		const response = await axios.get(`${import.meta.env.VITE_API_URL}/customer/${email}/details`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});

		if (response.status !== 200) {
			if (setError) setError(response.data);
			return [null, response.data];
		}

		if (setState) setState(response.data);
		return [response.data, null];
	} catch (error) {
		if (setError) setError(error as string);
		return [null, error as string];
	}

	return [null, null];
};
